<template>
    <div class="contentblock contentblock--gray contentblock--no-margin-and-padding">
        <section class="contentblock__content">
            <ul class="pneu-offer__progressbar">
                <li v-for="(step, index) in Steps"
                    @click="clickStep(index)"
                    :class="{ active: index <= currentStepIndex, current: index == currentStepIndex, clickable: allowNavigation && index < currentStepIndex }"
                    :key="index"><span class="shop__progressbar_steptext">{{step}}</span></li>
            </ul>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            currentStepIndex: {
                type: Number,
                required: true
            },
            allowNavigation: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        computed: {
            ...mapState([
                'strings'
            ]),
            Steps() {
                return new Array(
                    this.strings['PneuOffer.Progressbar_Step1'],
                    this.strings['PneuOffer.Progressbar_Step2'],
                    this.strings['PneuOffer.Progressbar_Step3'],
                    this.strings['PneuOffer.Progressbar_Step4'],
                    this.strings['PneuOffer.Progressbar_Step5']
                );
            }
        },
        methods: {
            clickStep(stepIndex) {
                if (this.allowNavigation && stepIndex < this.currentStepIndex) {
                    this.$router.push('/step' + (stepIndex + 1)).catch(() => { });
                }
            }
        }
    };
</script>